<template>
	<div class="actlist">
		
		<div class="top">
			<div class="l_c">
				<div class="title">引领示范活动</div>
				<div class="line"></div>
			</div>
			<div class="r_c">
				<span @click="tomore">查看更多</span>
				<img src="../../assets/img/leftarrow@2x.png" @click="tomore"/>
			</div>			
		</div>
		
		<div class="black_c">
			<div class="signle" v-for="(item,index) in list" :key="index" @click="todetail(item)">
				<div class="imgcon">
					<img :src="$util.imgSrc(item.coverMap)" />
				</div>
				
				<div class="informcon">
					<div class="title overf-elli" :title="item.name">{{item.name?item.name:''}}</div>
					<div class="other">
						<div class="l_c">
							<!-- <img src="../../assets/img/position@2x.png" />
							<div>大海区</div>
							<div class="line"></div> -->
							<div>已报名{{item.isNumber?item.isNumber:0}}人</div>
						</div>
						<div class="r_c">报名截止：{{item.deadline|getval}}</div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
	
</template>

<script>
import dataFn from '../../utils/date.js';
export default {
  props:['list'],
  filters:{ 
	  getval(val){ 
		  var time='';
		 if(val){ 
			 time=dataFn.GetNumberOfDays(dataFn.date, val,1);
		 }
		if(time.indexOf('-')!=-1){ 
			return '已截止'
		}
		return time
	  }
  },
  data: function() {
		return {
		};
  },
  
  mounted() {
	
  },

  methods: {
		tomore(){
			this.$router.push({ path: '/jumppage/actlist'});	
		},
		
		todetail(item){
			this.$router.push({ path: '/jumppage/actlistdetail', query: {id:item.id}});
		},
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.actlist{
	
	.top{
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 2px solid #F1F1F1;
		.l_c{
			.title{
				font-size: 30px;
				font-weight: 400;
				color: #333333;
			}		
			.line{
			    margin-top: 10px;
				width: 106px;
				height: 5px;
				background: #BA0711;
			}
		}
		.r_c{
			display: flex;
			align-items: center;
			span{
				cursor: pointer;
				font-size: 16px;
				font-weight: 400;
				color: #AA0F14;
			}
			img{
				cursor: pointer;
				margin-left: 80px;
				height: 34px;
				width: 34px;
			}
		}
		
	}
	
	.black_c{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.signle{
			cursor: pointer;
			margin-top: 50px;
			width: 590px;
			height: 340px;
			background: #FFFFFF;
			border: 1px solid #E0E0E0;
			border-radius: 5px;
			.imgcon{
				height: 221px;
				overflow: hidden;
				img{
					width: 100%;
					// height: 221px;
				}
			}
			.informcon{
				padding: 20px;
				.title{
					height: 50px;
					line-height: 50px;
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
				.other{
					display: flex;
					justify-content: space-between;
					.l_c{
						display: flex;
						align-items: center;
						font-size: 14px;
						font-weight: 400;
						color: #666666;
						img{
							height: 20px;
							width: 18px;
							margin-right: 10px;
						}
						.line{
							margin-left: 10px;
							margin-right: 10px;
							height: 16px;
							border: 1px solid #999999;
						}
					}
					.r_c{
						font-size: 14px;
						font-weight: 400;
						color: #666666
					}
				}
			}
		}
		
		.signle:hover{
			transform: translateY(-10px);
			box-shadow:  5px 5px 8px rgba(0, 0, 0, 0.3);
		}
		
	}
	
	
}

</style>
